module.exports = __webpack_public_path__ + "static/media/YoungWoman.7b08efb1.png";